import {Component} from "react";

export class TopLive extends Component<TopLiveProperties,TopLiveState> {

    render() {
        return <nav className="navbar" style={{backgroundColor: "#ffeb00", flexShrink: 0}}>
            <div className="container-fluid">
                <div className={"row col-12"}>
                    <div className={"col-2 text-start"}><h1 className={"flextext"}>{process.env.REACT_APP_PRODUCT_NAME}</h1></div>
                    <div className={"col-8 text-center"}><h1 className={"flextext"}>{this.props.titel}</h1></div>
                    <div className={"col-2 text-end flextext"}>by {process.env.REACT_APP_COMPANY_NAME}</div>
                </div>
            </div>
        </nav>
    }
}

interface TopLiveProperties {
    titel: string;
}

interface TopLiveState {

}